
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/facebook-fashion-index",
      function () {
        return require("private-next-pages/facebook-fashion-index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/facebook-fashion-index"])
      });
    }
  